import { Fragment, FunctionComponent } from 'react'
import { useHistory } from 'react-router'

import CallRestartedModal from '@/modules/RealtimeAttendance/components/CallRestartedModal'
import CallStartedModal from '@/modules/RealtimeAttendance/components/CallStartedModal'
import AttendanceStartedModal from '@/modules/RealtimeAttendance/components/AttendanceStartedModal'
import ScheduledCallStartedModal from '@/modules/RealtimeAttendance/components/ScheduledCallStartedModal'
import AttendanceLate from '@/modules/RealtimeAttendance/components/AttendanceLate'
import RescheduledByMedicModal from '@/modules/RealtimeAttendance/components/RescheduledByMedicModal'
import CancelledByTimeModal from '../components/CancelledByTimeModal'
import TokeValidationModal from '@/modules/RealtimeAttendance/components/TokenValidationModal'

const RealtimeAttendance: FunctionComponent = () => {
  const history = useHistory()

  return (
    <Fragment>
      <CallRestartedModal hookSuccess={() => history.push('/chamada')} />
      <CallStartedModal hookSuccess={() => history.push('/chamada')} />
      <ScheduledCallStartedModal hookSuccess={() => history.push('/chamada')} />
      <AttendanceStartedModal />
      <AttendanceLate />
      <RescheduledByMedicModal />
      <CancelledByTimeModal
        hookSuccess={() =>
          history.push('/atendimento-agendado/preferencia/medico')
        }
        hookFailed={() => history.push('/')}
        speciality={null}
      />
      <TokeValidationModal
        onActionClick={cb => {
          history.push('/chamada')
          cb()
        }}
      />
    </Fragment>
  )
}

export default RealtimeAttendance
